import type { Props } from './Svg'
import { Svg } from './Svg'

export function ChevronUpIcon(props: Props) {
  return (
    <Svg width="18" height="18" {...props}>
      <path strokeWidth="2" d="M13.5 11.25 9 6.75l-4.5 4.5" />
    </Svg>
  )
}
